// extracted by mini-css-extract-plugin
export default {"pricesSwitcherContainer":"dcc_cartboxPriceViewSwitcher-pricesSwitcherContainer"};